var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 155.174,
    height: 142.171,
    viewBox: "0 0 155.174 142.171",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.9,
    height: 1.975,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.784,
    height: 50.228,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3.258,
    height: 7.424,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29.952,
    height: 12.175,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.06,
    height: 49.394,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.653,
    height: 17.512,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M866.653,300.567a57.82,57.82,0,1,0,57.82-57.82,57.82,57.82,0,0,0-57.82,57.82v0",
    transform: "translate(-866.653 -242.747)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "n"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M943.642,234.128c-.532.68-.235,1.166-.659,2.254a5.12,5.12,0,0,1-1.607,2.119l1.315,1.17a5.743,5.743,0,0,1,1.9-2.41,10.917,10.917,0,0,0,1.39-.877c.745-.657,1.677-1.886,1.258-2.594a1.208,1.208,0,0,0-.6-.472,2.7,2.7,0,0,0-3,.812",
    transform: "translate(-941.376 -233.153)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "o",
    x1: -120.359,
    y1: 39.182,
    x2: -120.333,
    y2: 39.182,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a5c5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6d6f72"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "p"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M964.62,230.009a1.219,1.219,0,0,0-.365.668c-.111.817,1.231,1.587,2.171,1.9a11.058,11.058,0,0,0,1.623.264,5.729,5.729,0,0,1,2.687,1.48l.75-1.594a5.12,5.12,0,0,1-2.306-1.317c-.813-.838-.734-1.4-1.486-1.821a2.7,2.7,0,0,0-3.079.419",
    transform: "translate(-964.249 -229.284)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "q",
    x1: -115.08,
    y1: 55.163,
    x2: -115.057,
    y2: 55.163,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "r"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M958.044,258.343c-.1,2.06,2.228,1.913,2.228,1.913l-.088,1.3a2.813,2.813,0,0,1-1.838,2.455l-.912.336s5.988,1.282,9.257-1.028l-.943-.091a2.817,2.817,0,0,1-2.527-2.515l-.057-.556s1.035-6.425-3.458-6.806a15.416,15.416,0,0,0-1.662,4.993",
    transform: "translate(-957.434 -253.35)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "s",
    x1: -53.562,
    y1: 15.214,
    x2: -53.557,
    y2: 15.214,
    xlinkHref: "#o"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "t"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M958.594,251.2c-.926,2.032,1.056,5.359,2.006,5.282.3-.025.564-.419.776-.3s.2.7,0,1.1a1.448,1.448,0,0,1-.562.6,3.757,3.757,0,0,1,.665,1.519,5.234,5.234,0,0,1-.838,3.388c-1.483,3.155.824,8.15,3.354,10.67,2.057,2.05,3.018,1.224,4.246,2.9,2.391,3.258-.909,6.838.328,11.224,1.881,6.667,12.411,8.651,12.846,8.73.173.028.287.049.466.075,4.723.752,11.882,1.886,16.923-1.991,3.773-2.9,5.5-7.946,5.217-12.393a14.351,14.351,0,0,0-4.048-9.237c-.57-.574-3.972-3.973-8.566-4.014a8.934,8.934,0,0,0-2.148.24,4.454,4.454,0,0,1-2.637.065c-2.549-.725-4.115-3.045-5.091-4.479-1.791-2.64-1.062-3.207-2.351-4.506-2.524-2.547-5.486-.548-8.183-2.795-2.66-2.217-1.055-5.22-3.621-7.138a6.647,6.647,0,0,0-3.934-1.153c-2.131,0-4.208.813-4.853,2.224",
    transform: "translate(-958.353 -248.974)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "u",
    x1: -11.787,
    y1: 4.302,
    x2: -11.787,
    y2: 4.302,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9eaea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#101011"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "v"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.215,
    height: 0.378,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1107.643 -153.906)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M924.709,237.826a62.977,62.977,0,1,1-62.983,62.983,62.976,62.976,0,0,1,62.983-62.983h0",
    transform: "translate(252.656 -68.073)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.726,364.167a63.347,63.347,0,1,1,63.342-63.352v0a63.347,63.347,0,0,1-63.346,63.348m0-125.955a62.608,62.608,0,1,0,62.612,62.609h0a62.68,62.68,0,0,0-62.608-62.608",
    transform: "translate(252.639 -68.09)",
    fill: "#d9dadc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.473,242.744a57.82,57.82,0,1,1-57.82,57.822,57.82,57.82,0,0,1,57.82-57.822h0",
    transform: "translate(252.893 -67.837)",
    fill: "#8a8d90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M924.473,242.744a57.82,57.82,0,1,1-57.82,57.822,57.82,57.82,0,0,1,57.82-57.822h0",
    transform: "translate(252.893 -67.837)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M928.2,231.9a17.878,17.878,0,0,0-7.021-7.112c-.111-.063-.227-.119-.339-.181A14.21,14.21,0,0,0,912.1,222.8c-4.257.647-8.416,3.944-11.2,7.152-.085.1-.171.192-.25.289q-.635.761-1.165,1.488c-2.145,2.979-2.873,5.554-5.588,6.338-2.775.8-4.352-1.2-6.778-.792a4.219,4.219,0,0,0-.419.118,3.131,3.131,0,0,0-.347.1c-4.384,1.648-6.369,10.432-6.707,11.918-3.944,17.5,5.256,35.154,9.358,42.807,1.153,2.15,2.578,4.611,4.3,7.291.184.287.368.572.56.867,1.685,2.56,3.652,5.308,5.937,8.162q.923,1.152,1.916,2.321c1.672,1.977,3.486,3.991,5.476,6.025-2.066-5.512-4.247-13.884-2.451-23.312a31.249,31.249,0,0,1,2.945-8.619c.085-.168.173-.333.259-.5,2.591-4.882,6.26-9.222,10.51-16.7.064-.1.125-.218.189-.331,1.34-2.379,2.74-5.067,4.177-8.193,1.635-3.554,3.105-6.773,4.264-9.757.12-.3.233-.606.344-.9,2.44-6.514,3.265-11.83.774-16.671",
    transform: "translate(253.47 -68.798)",
    fill: "#6e7073"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.118,259.253h.275a31.615,31.615,0,0,0,22.344-9.868c.119-.3.233-.609.344-.906A31.209,31.209,0,0,1,904.356,258.9c2.173-3.223,4.133-5.714,5.919-7.973,3.274-4.143,5.861-7.414,7.935-12.995a43.218,43.218,0,0,0,2.619-13.239c-.111-.063-.227-.119-.339-.179a43.036,43.036,0,0,1-2.606,13.3c-2.057,5.523-4.628,8.776-7.883,12.89-1.726,2.177-3.605,4.568-5.685,7.626a48.8,48.8,0,0,0-2.781-26.266c-.322-.782-.653-1.522-.986-2.213-.083.1-.169.194-.248.29.3.652.618,1.34.913,2.073A48.565,48.565,0,0,1,903.852,259c-.812,1.217-1.657,2.536-2.538,3.994a119.9,119.9,0,0,0-6.044,10.813c-5.186-4.974-7.349-16.5-8.245-25.341-.419-4.1-.609-8.02-.686-11.177a3.137,3.137,0,0,0-.347.1c.083,3.144.271,7.031.685,11.109,1.319,13,4.162,21.622,8.434,25.644a32.289,32.289,0,0,0-2.223,6.416c-1.4,6.307-.507,13.184,2.66,20.484v.275c-.438-.3-1.356-.943-2.6-1.907.185.287.367.572.559.867,1.32.989,2.122,1.516,2.143,1.53l.29.189-.007-.1c.368.807.753,1.613,1.175,2.428.7,1.362,1.488,2.735,2.334,4.112q.923,1.152,1.916,2.321a65.369,65.369,0,0,1-3.942-6.6q-.83-1.607-1.518-3.186a15.108,15.108,0,0,1,2.64-9.237,19.848,19.848,0,0,1,6.812-5.9c.66-.368,1.32-.7,1.978-1,.085-.168.173-.333.259-.5-.789.349-1.6.734-2.4,1.183-4.4,2.443-9.484,6.926-9.641,14.586-2.864-6.941-3.647-13.481-2.314-19.492a31.861,31.861,0,0,1,2.221-6.408,88.1,88.1,0,0,1,13.7-6.006,22.591,22.591,0,0,1,8.944-.562c.062-.1.125-.218.187-.331a23.158,23.158,0,0,0-9.237.562,88.663,88.663,0,0,0-13.333,5.8c1.513-3.194,3.51-6.53,5.905-10.507.873-1.416,1.705-2.714,2.506-3.915",
    transform: "translate(253.82 -68.711)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.887,309.555c-.2-.227-.394-.453-.59-.678a66.1,66.1,0,0,1-12.934-21.9c-2.122-6.209-1.985-9.214-3.563-15.577-.091-.37-.191-.758-.294-1.153-.383-1.442-.838-3.039-1.436-4.88a106.711,106.711,0,0,0-4.769-12.995c-.122-.25-.244-.495-.37-.734-2.171-4.208-4.762-6.851-8.84-7.844a17.266,17.266,0,0,0-5.456-.365c-.118.008-.236.021-.356.031a17.189,17.189,0,0,0-9.548,3.784,9.612,9.612,0,0,0-1.612,1.918c-.09.137-.187.272-.269.419-3.227,5.546-.585,13.39.407,16.322,1.915,5.659,4.733,7.948,3.427,12.46-.857,2.968-2.62,3.885-3.727,5.5-.064.1-.13.194-.192.3a5.121,5.121,0,0,0-.554,1.3c-2.195,8.121,15.615,16.392,18.494,17.731,11.3,5.24,23.129,6.6,32.421,6.638-.08-.091-.155-.183-.238-.275",
    transform: "translate(252.348 -67.808)",
    fill: "#7a7e81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M906.232,308.871a60.893,60.893,0,0,1-20.818-18.3c-.028-.042-.058-.085-.088-.124a57.32,57.32,0,0,0,4.412-19.057c-.091-.37-.191-.758-.294-1.153a57.9,57.9,0,0,1-4.353,19.88,89.86,89.86,0,0,1-9.44-16.509A38.58,38.58,0,0,0,880.4,265.5a32.33,32.33,0,0,0,2.83-13.133q-.182-.376-.368-.734a31.651,31.651,0,0,1-2.779,13.719,38.645,38.645,0,0,1-4.6,7.893,111.862,111.862,0,0,1-6.137-18.172,35.511,35.511,0,0,1-.782-11.646c-.118.008-.236.021-.354.031a35.855,35.855,0,0,0,.8,11.7,112.333,112.333,0,0,0,6.03,17.939c-12.471-8.408-16.711-17.467-17.992-23.931-.09.139-.189.272-.269.419,1.393,6.59,5.82,15.708,18.524,24.115a90.391,90.391,0,0,0,9.51,16.64c-6.657.877-16.151.9-24.153-3.773a24.707,24.707,0,0,1-3.773-2.7c-.067.1-.132.194-.194.3a25.151,25.151,0,0,0,3.763,2.689c3.584,2.1,9.314,4.3,17.59,4.3a51.8,51.8,0,0,0,6.99-.489c.031.042.06.083.088.125a60.886,60.886,0,0,0,21.691,18.768c-.2-.228-.394-.455-.588-.68",
    transform: "translate(252.415 -67.805)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.352,276.461a8.222,8.222,0,0,1,.867-3.7,8.413,8.413,0,0,0-.914,3.822V281.4l.047-.14Z",
    transform: "translate(253.02 -66.396)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.382,272.423c.075-.129.145-.262.227-.388-.083.125-.152.259-.227.388",
    transform: "translate(253.072 -66.432)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.545,269.669c.111-.184.22-.372.334-.556a6.955,6.955,0,0,0-2.467,1.1c.187.176.378.35.575.524a7.484,7.484,0,0,1,1.557-1.066",
    transform: "translate(253.169 -66.572)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.258,268.97H876a5.629,5.629,0,0,0-1.219.15c-.113.184-.222.372-.333.556a6.176,6.176,0,0,1,2.809-.706",
    transform: "translate(253.267 -66.579)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.352,280.866l-.047.14v35.453l.047.14Z",
    transform: "translate(253.02 -66.008)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.347,281.006v.4h.135c-.042-.132-.091-.266-.135-.4",
    transform: "translate(258.059 -66.001)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.163,345.3l.145.088,66.868-5.051a1.261,1.261,0,0,1,.124-.1Z",
    transform: "translate(254.164 -63.16)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.123,345.279l.037.025,67.138-5.076.031-.028Z",
    transform: "translate(254.162 -63.161)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.681 203.63)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.436,270.2c.02-.013.041-.025.063-.037l-.016-.014a7.362,7.362,0,0,0-1.886,1.976,7.218,7.218,0,0,1,1.837-1.925",
    transform: "translate(-870.597 -270.152)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M869.35,281.381c.357-1.106.753-2.2,1.177-3.272v-1.4a8.145,8.145,0,0,1,2.544-5.973c.021-.019.042-.036.064-.052-.2-.169-.391-.345-.577-.524l-.062.037a7.23,7.23,0,0,0-1.837,1.928c-.083.125-.152.259-.227.388s-.15.248-.215.378a8.222,8.222,0,0,0-.867,3.7Z",
    transform: "translate(253.022 -66.521)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.527,300.117V277.746c-.419,1.076-.818,2.166-1.177,3.271v35.736c.357,1.106.753,2.2,1.177,3.272Z",
    transform: "translate(253.022 -66.157)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1122.372 203.644)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.006 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.559,270.165l-.064.037a7.224,7.224,0,0,0-1.835,1.928c-.083.125-.152.259-.229.388s-.148.248-.21.378a8.2,8.2,0,0,0-.865,3.7v40.531c.357,1.1.753,2.194,1.176,3.271V276.713a8.141,8.141,0,0,1,2.544-5.973l.062-.052c-.2-.169-.391-.344-.575-.524",
    transform: "translate(-869.356 -270.163)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M975.026,268.97H877.447a6.185,6.185,0,0,0-2.811.709,7.569,7.569,0,0,0-1.557,1.067.769.769,0,0,1-.064.052,8.159,8.159,0,0,0-2.544,5.973v6.659l29.952-.4,78.906-1.048v-.406c.046.134.1.262.135.4l1.266-.018v-5.973c0-3.8-2.568-7.021-5.7-7.021",
    transform: "translate(253.076 -66.579)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.333,296.074,913.129,298l-42.653,1.242v19.9A58.01,58.01,0,0,0,894.211,347.4l67.2-5.078a58.555,58.555,0,0,0,5.113-4.852,57.742,57.742,0,0,0,12.8-21.739q.819-2.545,1.4-5.186V296.033Zm-75.082,33.863-26.6,1.572V327.7l26.6-1.478Zm0-7.174-26.6,1.389V320.6l26.6-1.3ZM920.7,315.8l-43.056,2v-7.865L920.7,308.25Z",
    transform: "translate(253.076 -65.28)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.465,281.387h-.132l-78.906,1.048-29.95.4v17.113L913.13,298.7l66.207-1.928,1.4-.041V281.369Z",
    transform: "translate(253.076 -65.983)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.323,317.249l43.053-2.006V307.7l-43.053,1.689Z",
    transform: "translate(253.404 -64.721)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.323,323.086l26.6-1.392v-3.464l-26.6,1.3Z",
    transform: "translate(253.404 -64.216)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.323,330.128l26.6-1.572v-3.712l-26.6,1.478Z",
    transform: "translate(253.404 -63.898)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.552 204.163)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M873.287,270.832c-.069-.057-.137-.111-.2-.169-.021.018-.042.034-.063.052a8.145,8.145,0,0,0-2.544,5.973v1.395a57.723,57.723,0,0,1,3.258-6.917c-.152-.111-.3-.22-.447-.34",
    transform: "translate(-870.477 -270.663)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.549 204.675)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.422,282.925l-.039-.127a11.451,11.451,0,0,0-3.871-5.583c-7.511-6.072-15.595-.7-22.782-6.066a57.717,57.717,0,0,0-3.258,6.917v5.261Z",
    transform: "translate(-870.472 -271.15)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.549 232.721)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M966.532,337.379c-.3-.241-.588-.482-.861-.727-6.845-6.078-5.659-12.067-13.04-16.06-9.209-4.982-16.446,1.331-23.431-4.9-4.236-3.773-2.159-6.592-7.368-12.235-3.31-3.584-5.96-4.422-8.707-5.548l-42.653,1.242v19.905A58.017,58.017,0,0,0,894.208,347.3l67.207-5.075a58.556,58.556,0,0,0,5.116-4.85m-62.281-7.533-26.6,1.572v-3.806l26.6-1.478Zm0-7.174-26.6,1.39v-3.553l26.6-1.3Zm16.453-6.96-43.053,2.006v-7.865L920.7,308.16Z",
    transform: "translate(-870.473 -297.909)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.549 216.451)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.006 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.473,299.9l42.653-1.24-.287-.119a18.66,18.66,0,0,1-6.34-4.115c-4.705-4.562-4.886-8.473-6.078-12.039l-29.952.4Z",
    transform: "translate(-870.468 -282.385)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M869.352,276.461a8.222,8.222,0,0,1,.867-3.7,8.413,8.413,0,0,0-.914,3.822V281.4l.047-.14Z",
    transform: "translate(253.02 -66.396)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.382,272.423c.075-.129.145-.262.227-.388-.083.125-.152.259-.227.388",
    transform: "translate(253.072 -66.432)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M874.545,269.669c.111-.184.22-.372.334-.556a6.955,6.955,0,0,0-2.467,1.1c.187.176.378.35.575.524a7.484,7.484,0,0,1,1.557-1.066",
    transform: "translate(253.169 -66.572)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.258,268.97H876a5.629,5.629,0,0,0-1.219.15c-.113.184-.222.372-.333.556a6.176,6.176,0,0,1,2.809-.706",
    transform: "translate(253.267 -66.579)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M869.352,280.866l-.047.14v35.453l.047.14Z",
    transform: "translate(253.02 -66.008)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M974.347,281.006v.4h.135c-.042-.132-.091-.266-.135-.4",
    transform: "translate(258.059 -66.001)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.163,345.3l.145.088,66.868-5.051a1.261,1.261,0,0,1,.124-.1Z",
    transform: "translate(254.164 -63.16)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M893.123,345.279l.037.025,67.138-5.076.031-.028Z",
    transform: "translate(254.162 -63.161)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.681 203.63)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.002 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.436,270.2c.02-.013.041-.025.063-.037l-.016-.014a7.362,7.362,0,0,0-1.886,1.976,7.218,7.218,0,0,1,1.837-1.925",
    transform: "translate(-870.597 -270.152)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M869.35,281.381c.357-1.106.753-2.2,1.177-3.272v-1.4a8.145,8.145,0,0,1,2.544-5.973c.021-.019.042-.036.064-.052-.2-.169-.391-.345-.577-.524l-.062.037a7.23,7.23,0,0,0-1.837,1.928c-.083.125-.152.259-.227.388s-.15.248-.215.378a8.222,8.222,0,0,0-.867,3.7Z",
    transform: "translate(253.022 -66.521)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.527,300.117V277.746c-.419,1.076-.818,2.166-1.177,3.271v35.736c.357,1.106.753,2.2,1.177,3.272Z",
    transform: "translate(253.022 -66.157)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1122.372 203.644)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.006 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M872.559,270.165l-.064.037a7.224,7.224,0,0,0-1.835,1.928c-.083.125-.152.259-.229.388s-.148.248-.21.378a8.2,8.2,0,0,0-.865,3.7v40.531c.357,1.1.753,2.194,1.176,3.271V276.713a8.141,8.141,0,0,1,2.544-5.973l.062-.052c-.2-.169-.391-.344-.575-.524",
    transform: "translate(-869.356 -270.163)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M975.026,268.97H877.447a6.185,6.185,0,0,0-2.811.709,7.569,7.569,0,0,0-1.557,1.067.769.769,0,0,1-.064.052,8.159,8.159,0,0,0-2.544,5.973v6.659l29.952-.4,78.906-1.048v-.406c.046.134.1.262.135.4l1.266-.018v-5.973c0-3.8-2.568-7.021-5.7-7.021",
    transform: "translate(253.076 -66.579)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.333,296.074,913.129,298l-42.653,1.242v19.9A58.01,58.01,0,0,0,894.211,347.4l67.2-5.078a58.555,58.555,0,0,0,5.113-4.852,57.742,57.742,0,0,0,12.8-21.739q.819-2.545,1.4-5.186V296.033Zm-75.082,33.863-26.6,1.572V327.7l26.6-1.478Zm0-7.174-26.6,1.389V320.6l26.6-1.3ZM920.7,315.8l-43.056,2v-7.865L920.7,308.25Z",
    transform: "translate(253.076 -65.28)",
    fill: "#393a3c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M979.465,281.387h-.132l-78.906,1.048-29.95.4v17.113L913.13,298.7l66.207-1.928,1.4-.041V281.369Z",
    transform: "translate(253.076 -65.983)",
    fill: "#252526"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.323,317.249l43.053-2.006V307.7l-43.053,1.689Z",
    transform: "translate(253.404 -64.721)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.323,323.086l26.6-1.392v-3.464l-26.6,1.3Z",
    transform: "translate(253.404 -64.216)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.323,330.128l26.6-1.572v-3.712l-26.6,1.478Z",
    transform: "translate(253.404 -63.898)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.552 204.163)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M873.287,270.832c-.069-.057-.137-.111-.2-.169-.021.018-.042.034-.063.052a8.145,8.145,0,0,0-2.544,5.973v1.395a57.723,57.723,0,0,1,3.258-6.917c-.152-.111-.3-.22-.447-.34",
    transform: "translate(-870.477 -270.663)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.549 204.675)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.001 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M900.422,282.925l-.039-.127a11.451,11.451,0,0,0-3.871-5.583c-7.511-6.072-15.595-.7-22.782-6.066a57.717,57.717,0,0,0-3.258,6.917v5.261Z",
    transform: "translate(-870.472 -271.15)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.549 232.721)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -0.002)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M966.532,337.379c-.3-.241-.588-.482-.861-.727-6.845-6.078-5.659-12.067-13.04-16.06-9.209-4.982-16.446,1.331-23.431-4.9-4.236-3.773-2.159-6.592-7.368-12.235-3.31-3.584-5.96-4.422-8.707-5.548l-42.653,1.242v19.905A58.017,58.017,0,0,0,894.208,347.3l67.207-5.075a58.556,58.556,0,0,0,5.116-4.85m-62.281-7.533-26.6,1.572v-3.806l26.6-1.478Zm0-7.174-26.6,1.39v-3.553l26.6-1.3Zm16.453-6.96-43.053,2.006v-7.865L920.7,308.16Z",
    transform: "translate(-870.473 -297.909)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.549 216.451)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.006 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.473,299.9l42.653-1.24-.287-.119a18.66,18.66,0,0,1-6.34-4.115c-4.705-4.562-4.886-8.473-6.078-12.039l-29.952.4Z",
    transform: "translate(-870.468 -282.385)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1115.546 174.91)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#m)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(79.934 61.825)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M974.336,306.915a86.334,86.334,0,0,1-1.827,15.577c-.97,4.583-1.534,5.38-1.837,8.545-.657,6.9,1.566,7.885,1.972,15.678a47.46,47.46,0,0,1-2.74,18.057,49.11,49.11,0,0,1-2.233,5.4c-.789.689-2,.424-3.269.168-.466-7.807-1.048-15.155-1.522-22.962q-2.268-17.614-4.535-35.232,8-2.62,15.989-5.234",
    transform: "translate(-942.188 -301.494)",
    fill: "#e9eaea"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M964.414,370.341c-.466-7.807-1.048-15.155-1.524-22.96l-4.534-35.233,15.981-5.233c-.01.407-.031.792-.046,1.19-7.474,6.49-8.938,11.633-8.866,15.14.09,4.253,2.41,6.363,1.96,12.531-.324,4.41-1.651,5.186-1.648,9.167,0,5.124,2.2,8,3.271,10.962,1.035,2.862,1.4,6.917-.6,12.681-.262.6-.507,1.128-.734,1.583-.785.691-1.991.428-3.266.169",
    transform: "translate(-942.188 -301.494)",
    fill: "#0f0f0f"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M951.377,301.742a82.619,82.619,0,0,0-8.174,27.023c-.461,3.982-.419,6.437.734,8.908,4.1,8.85,18.418,9.432,20.595,9.495l2.147-4.4a21.985,21.985,0,0,0-7.552-8.309c-3.028-1.9-4.209-1.5-4.966-2.775-3.031-5.135,13.338-16.244,10.891-23.652-.846-2.555-4.1-5.152-13.667-6.288",
    transform: "translate(-942.928 -301.742)",
    fill: "#0f0f0f"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1193.853 164.856)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#n)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.081 -1.248)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M940.344,233.43l1.294,7.539,7.147-1.467-1.294-7.539Z",
    transform: "translate(-940.344 -231.963)",
    fill: "url(#o)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1217.823 160.802)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#p)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.955 -0.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963.338,229.382l.953,5.563,8.091-.67-.957-5.563Z",
    transform: "translate(-963.338 -228.712)",
    fill: "url(#q)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1202.083 162.803)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M968.776,233.645c-.419,1.972,1.719,3.73,3.258,5.449,3.087,3.458,6.317,9.628,5.135,14.92a11.517,11.517,0,0,1-5.659,7.5c-3.158,1.594-5.049.143-8.332,2.039-.245.139-4.4,2.6-4.517,5.924-.148,4.1,5.879,8.46,11.037,8.794,9.432.609,20.81-11.937,20.276-24.388-.577-13.553-15.142-24.313-19.332-22.49a3.461,3.461,0,0,0-1.863,2.246",
    transform: "translate(-948.776 -231.194)",
    fill: "#878a8d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963.155,262.792c-6.022,1.033-10.606,2.11-12.652,5.262-2.161,3.333,1.276,5.84,2.21,13.147,1.431,11.188-5,15.37-3.144,26.633a28.735,28.735,0,0,0,1.258,4.873,11.526,11.526,0,0,0,4.757,5.912,29.877,29.877,0,0,0,6.027,2.913c6.105,2.131,9.117.893,17.331,1.362,13.436.769,15.447,4.671,21.519,2.27,6.136-2.423,10.575-8.966,9.275-11.762-.779-1.677-3.237-.629-6.763-2.684-4.544-2.65-3.779-6.268-7.467-9.369-5.3-4.457-10.389.044-14.92-3.83-4.583-3.92-5.129-13.453-3.183-19.128,1.273-3.707,1.3-7.738,2.241-11.54a2.423,2.423,0,0,0-.054-1.392c-.75-2.186-4.752-2.6-7.775-2.9a34.5,34.5,0,0,0-8.651.228",
    transform: "translate(-949.229 -229.697)",
    fill: "#9a9da0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M999.742,319.487c-1.863-1.242-.854-4.755-3.61-6.62-2.557-1.731-4.549.533-8.321-.621-4.834-1.481-4.583-6.136-9.214-7.622-3.333-1.067-4.335,1.058-9.135,1.153a19.109,19.109,0,0,1-15.067-6.97,17.15,17.15,0,0,1-3.144-6.6c-1.281,4.144-2.673,8.15-1.677,14.2a28.861,28.861,0,0,0,1.749,6.183,8.572,8.572,0,0,0,3.039,3.8,30.048,30.048,0,0,0,7.247,3.721c6.105,2.131,9.117.893,17.331,1.362,13.436.769,15.447,4.671,21.518,2.27a17.42,17.42,0,0,0,8.621-7.64c-5.318,3.864-7.984,4.3-9.332,3.4",
    transform: "translate(-949.228 -228.267)",
    fill: "#878a8d"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1210.682 186.021)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#r)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4.823 -5.465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M961.032,248.135l-8.2,13.264,10.7,9.947,8.2-13.264Z",
    transform: "translate(-952.832 -248.135)",
    fill: "url(#s)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1181.534 169.16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M944.972,238.923c.943,1.782-.623,4.06-1.623,6.138-2.014,4.176-3.418,11-.818,15.758a11.509,11.509,0,0,0,7.511,5.65c3.475.664,4.892-1.252,8.573-.336.269.067,4.942,1.289,5.973,4.449,1.273,3.9-3.316,9.754-8.186,11.5-8.9,3.189-23.289-5.736-26.213-17.851-3.184-13.188,7.847-27.546,12.383-26.949a3.448,3.448,0,0,1,2.4,1.645",
    transform: "translate(-929.621 -237.26)",
    fill: "#9a9da0"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1211.645 181.437)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#t)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19.24 -19.496)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M996.069,318.655l27.677-59.148-56.077-29.136-27.675,59.145Z",
    transform: "translate(-939.994 -230.371)",
    fill: "url(#u)"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M673.465,342.628a3.4,3.4,0,0,1-1.49-.962,2.071,2.071,0,0,1-.518-1.374,1.83,1.83,0,0,1,.042-.465,1.257,1.257,0,0,1,.539-.877,1.782,1.782,0,0,1,1-.285,1.146,1.146,0,0,1,.782.243.641.641,0,0,1,.21.624,3.514,3.514,0,0,0-.064.655,1.448,1.448,0,0,0,.507,1.194,2.259,2.259,0,0,0,1.458.412,2.864,2.864,0,0,0,2.071-.846,4.573,4.573,0,0,0,1.183-2.451,3.5,3.5,0,0,0,.085-.782,2.236,2.236,0,0,0-.57-1.585,2.114,2.114,0,0,0-1.628-.613h-2.038l.233-1.162h2.05a2.831,2.831,0,0,0,2.219-.95,4.646,4.646,0,0,0,1.1-2.135,4.293,4.293,0,0,0,.064-.676,1.606,1.606,0,0,0-.465-1.247,2.015,2.015,0,0,0-1.395-.419,2.88,2.88,0,0,0-1.86.592,2.733,2.733,0,0,0-.952,1.69,1.132,1.132,0,0,1-.476.655,1.552,1.552,0,0,1-.9.254,1.236,1.236,0,0,1-.771-.233.8.8,0,0,1-.306-.676,1.424,1.424,0,0,1,.021-.275,2.958,2.958,0,0,1,.951-1.6,5.527,5.527,0,0,1,2.018-1.153,8.281,8.281,0,0,1,2.694-.419,5.814,5.814,0,0,1,3.085.74,2.474,2.474,0,0,1,1.205,2.262,4.3,4.3,0,0,1-.085.867,3.827,3.827,0,0,1-1.183,2.018,4.751,4.751,0,0,1-2.156,1.194l-.021.085a3.465,3.465,0,0,1,1.617.983,2.467,2.467,0,0,1,.624,1.723,3.559,3.559,0,0,1-.085.8A4.965,4.965,0,0,1,680,341.873a7.922,7.922,0,0,1-4.247,1.11,6.743,6.743,0,0,1-2.29-.355",
    transform: "translate(513.314 -102.758)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.239 205.991)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.177,272.783c.065-.13.142-.251.215-.378-.072.127-.15.243-.215.378",
    transform: "translate(-870.177 -272.405)",
    fill: "#393a3c"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1123.239 205.991)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#v)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M870.177,272.783c.065-.13.142-.251.215-.378-.072.127-.15.243-.215.378",
    transform: "translate(-870.177 -272.405)",
    fill: "#fff"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdIcon);
export default __webpack_public_path__ + "static/media/third-icon.b0db2e52f2ddb24aac171a186f55224f.svg";
export { ForwardRef as ReactComponent };